// extracted by mini-css-extract-plugin
export default {"desktop":"Desktop_desktop__-cfVg"};